import React from 'react';
import { PopoverIcon } from './Icon.popover';

export const PostConstructionIcon = ({ task, isPostConstruction, className, isStage = false }) => {
  if (task) {
    isPostConstruction = task.get('cycleTimeType') === 'post-construction';
  }

  if (isPostConstruction !== true) return null;

  return (
    <PopoverIcon icon="broom-wide" className={className}>
      Post-Construction {isStage ? ' Stage' : 'Task'}. It will
      <br />
      not affect Job Exp. Finish date.
    </PopoverIcon>
  );
};
